<style lang="css" scope>
  .wz-comment-item {
      margin-bottom: 0.3rem;
  }
  .wz-comment-item .u-logo {
      width: 0.8rem;
      height: 0.8rem;
      float: left;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      border-radius: 50%;
  }
  .wz-comment-item .wz-comment-item__cont {
      margin-left: 1rem;
  }
  .wz-comment-item .cm-title {
    font-size: 0.3rem;
  }
  .wz-comment-item .cm-body {
    padding-top: 0.15rem;
    padding-bottom: 0.15rem;
    font-size: 0.24rem;
  }
  .wz-comment-item .cm-foot {
      color: #999;
  }
</style>
<template>
  <div class="wz-comment-item">
    <slot name="head"></slot>
    <img class="u-logo" :src="sUser.logoSrc" :alt="sUser.nick" />
    <div class="wz-comment-item__cont">
      <div class="cm-title">{{sUser.nick}}</div>
      <div class="cm-body">{{comment.content}}</div>
      <div class="cm-foot">
        <k-time :value="ctime" format="YYYY年M月D日 hh:mm:ss" />
        <slot name="tool"><span>12</span></slot>
      </div>
    </div>
    <slot name="foot"></slot>
  </div>
</template>

<script>
  export default {
    name: 'wz-comment-item',
    data() {
      return {}
    },
    props: {
      comment: {type: Object, default: null},
      users: {type: Object, default: null}
    },
    computed: {
      // 评论者
      sUser() {
        return this.getUser('suid')
      },
      // 关联用户（评论对象所属于用户）
      rUser() {
        return this.getUser('ruid')
      },
      // 参与者
      jUser() {
        return this.getUser('juid')
      },
      // 发布时间
      ctime() {
        return this.getInfo('ctime', '')
      }
    },
    methods: {
      getInfo(key, defValue) {
        const {comment} = this
        return comment && comment[key] != null ? comment[key] : defValue
      },
      getUser(key) {
        const {users} = this
        const uid = this.getInfo(key, 0)
        return uid > 0 && users && users[uid]
          ? users[uid]
          : null
      }
    },
    created() {},
    beforeDestroy() {}
  }
</script>
